module.exports = __webpack_public_path__ + "img/list12.8ae871d3.jpeg";